<template>
  <Card variant="tertiary" class="card-placeholder">
    <View v-if="isLoading" justify="center" align="center" padding="xl">
      <LoadingIndicator />
    </View>
    <View v-else justify="center" align="center" padding-inline="xl" direction="column" gap="sm">
      <IconTile size="medium" shape="rounded" :colored-icon="true" :icon="icon" color="blue-dust" />
      <Text variant="h5" align="center">{{ title }}</Text>
      <Text variant="body-medium" color="secondary" align="center">{{ description }}</Text>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, IconTile, IconName, LoadingIndicator, Text, View } from '@tallo/design-system';

defineProps<{ title: string; description: string; icon: IconName; isLoading?: boolean }>();
</script>

<style scoped lang="scss">
.card-placeholder {
  height: 100%;
  align-content: center;
}
</style>
